// Frontend mirrors of SOURCE_ANCHOR_RESOLVERS (server/app/engine/executor.py)
// — used by the Debug tab's "Resolved Source" panel to show which Source a
// step is actually anchored to, without re-running the pipeline. Keep in
// sync with the backend registry; this only re-derives the same answer for
// display, it doesn't add any new resolution behavior.

// Mirrors simple_source_anchor() — unconditional: cfg.source, whenever it
// isn't unset/"__self__", regardless of whether self has rows.
function simpleSourceAnchor(cfg) {
  const src = (cfg || {}).source;
  return src && src !== '__self__' ? src : null;
}

// Mirrors SOURCE_ANCHOR_RESOLVERS in server/app/engine/executor.py. Each
// resolver takes (cfg, selfCount) -> anchor name | null. `selfCount` is
// unused by the unconditional resolvers, same as the backend's `rows`
// param on simple_source_anchor — kept in the signature so every entry has
// one shape. Deliberately does NOT cover union yet, matching the backend
// registry's own known gap (see plan.md).
export const SOURCE_ANCHOR_RESOLVERS = {
  unpivot: simpleSourceAnchor,
  group_by: simpleSourceAnchor,
  compute: simpleSourceAnchor,
  case_when: simpleSourceAnchor,
};
